// extracted by mini-css-extract-plugin
export default {"add-seats-legend":"style_add-seats-legend__O6v-6","button-link":"style_button-link__Efh0c"};